import React from "react";
import { StyledFormElementsWrapper, ContainerGrid } from "../styles";
import CustomSelect from "./CustomSelect";
import FormField from "../../../common/FormField/FormField";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import COLORS from "../../../../assets/Colors";

const NoticeDesign = ({
  values,
  handleChange,
  errors,
  touched,
  handleBlur,
  setFieldValue,
  menuItems,
  getNoticeTemplates,
}) => {
  const inputs = [
    {
      type: "number",
      name: "lineSpacing",
      label: "Line Spacing",
      placeholder: "10",
    },
    {
      type: "number",
      name: "afterLineSpacing",
      label: "After Line Spacing",
      placeholder: "1",
    },
    {
      type: "number",
      name: "topMargin",
      label: "Top Margin",
      placeholder: "2.25",
    },
    {
      type: "number",
      name: "bottomMargin",
      label: "Bottom Margin",
      placeholder: "1.25",
    },
    {
      type: "number",
      name: "leftMargin",
      label: "Left Margin",
      placeholder: "1.5",
    },
    {
      type: "number",
      name: "rightMargin",
      label: "Right Margin",
      placeholder: "1.5",
    },
    {
      type: "number",
      name: "headerDistance",
      label: "Header Distance",
      placeholder: "0.25",
    },
    {
      type: "number",
      name: "footerDistance",
      label: "Footer Distance",
      placeholder: "0.25",
    },
    { type: "number", name: "fontSize", label: "Font Size", placeholder: "10" },
  ];

  const groups = [
    {
      title: "Spacing",
      fields: ["lineSpacing", "afterLineSpacing"],
    },
    {
      title: "Margins",
      fields: ["topMargin", "bottomMargin", "leftMargin", "rightMargin"],
    },
    {
      title: "Header & Footer",
      fields: ["headerDistance", "footerDistance"],
    },
    {
      title: "Typography",
      fields: ["fontSize"],
    },
  ];

  return (
    <StyledFormElementsWrapper
      style={{ marginBottom: 8, marginTop: 15 }}
      width="100%"
    >
      <SectionTitle>Notice Design Settings</SectionTitle>

      <ContainerGrid>
        <CustomSelect
          name="partyId"
          trigger={true}
          value={values["partyId"]}
          {...{ errors, touched, setFieldValue, menuItems, getNoticeTemplates }}
        />
      </ContainerGrid>

      {groups.map((group) => (
        <GroupBlock key={group.title}>
          <GroupLabel>{group.title}</GroupLabel>
          <DesignGrid>
            {inputs
              .filter((inp) => group.fields.includes(inp.name))
              .map((input, index) => (
                <FormField
                  key={index}
                  {...{
                    touched,
                    errors,
                    input,
                    values,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                  }}
                />
              ))}
          </DesignGrid>
        </GroupBlock>
      ))}
    </StyledFormElementsWrapper>
  );
};

export default NoticeDesign;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1.5px solid rgba(0, 131, 140, 0.1);
`;

const GroupBlock = styled.div`
  margin-top: 20px;
`;

const GroupLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 12px;
  font-weight: 700;
  color: ${COLORS.INPUT_LABEL};
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 12px;

  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: rgba(0, 131, 140, 0.12);
  }
`;

const DesignGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
`;
